// Global Imports
import ReactDOM from "react-dom";
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Global Styles
import './styles/main.scss';

// Partials
import Header from "./partials/header";
import Footer from "./partials/footer";

// Routes
const Home = lazy(() => import('./controllers/home'));
const Clients = lazy(() => import('./controllers/clients'));
const Services = lazy(() => import('./controllers/services'));
const Projects = lazy(() => import('./controllers/projects'));
const Contact = lazy(() => import('./controllers/contact'));
const Error = lazy(() => import('./controllers/404'));


/*import { ROUTES, ROUTE } from "./helpers/navigation";
const RouteSetup = {ROUTES.map((route: ROUTE, i) => {
    return <Route path={route.path} component={route.component} />;
})}*/


// Create App
// @ts-ignore
const App = () => (
    <Router>
        <Header />
        <main>
            <Suspense fallback={<div className="loader">Loading...</div>}>
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route path="/clients" component={Clients}/>
                    <Route path="/projects" component={Projects}/>
                    <Route path="/services" component={Services}/>
                    <Route path="/contact" component={Contact}/>
                    <Route path="/*" component={Error}/>
                </Switch>
            </Suspense>
        </main>
        <Footer />
    </Router>
);

// Render App
ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.querySelector('.container')
);